<template>
  <div
    id="rollingCastle"
    style="background-color: white"
    :style="{ 'pointer-events': !gesture ? 'auto' : 'none' }"
  >
    <img :src="isamnet" width="100%" />
    <div class="ucf-revolver">
      <a class="closebutton" @click="is_expand ? compress() : close()"></a>
      <a
        v-show="iosFullscreen"
        class="ios-exit-fullscreen-btn"
        @click="exitFullscreen()"
      ></a>
      <div class="ucf-revolver-card-wrapper">
        <div class="ucf-revolver-card-scene">
          <div class="ucf-revolver-card-container">
            <div
              v-for="(card, index) in creative.cards"
              :key="index"
              :class="['ucf-revolver-cards', `card-${index + 1}`]"
            >
              <img :src="card.image_url" @click="expand(index)" />
            </div>
          </div>
        </div>
      </div>
      <div
        class="ucf-revolver-banner"
        :style="{
          'background-image': `url(${creative.background_image_url})`,
          'background-size': 'cover',
        }"
      >
        <div class="ucf-revolver-banner-scene">
          <div class="ucf-revolver-banner-container">
            <div
              v-for="(banner, index) in creative.banners"
              :key="index"
              :class="['ucf-revolver-banner-cards', `card-${index + 1}`]"
            >
              <a
                :href="banner.landing_page"
                target="_blank"
                v-if="banner.type === 'image'"
              >
                <div
                  id="image-div"
                  v-for="(image, index) in banner.images"
                  :key="index"
                  :class="[
                    {
                      float: image.type === 'fg' && image.is_float,
                    },
                  ]"
                  :style="
                    image.type === 'fg' ? 'transform: translateZ(20px)' : ''
                  "
                >
                  <img
                    :src="image.url"
                    :class="[
                      {
                        'background-image': image.type === 'bg',
                      },
                    ]"
                    :style="image.type === 'fg' ? setFgStyle(image) : {}"
                  />
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mixPreview from "@/components/mixins/preview.js";
import mixMobile from "@/components/mixins/mobile.js";
import mixOutstream from "@/components/mixins/outstream.js";
import mixYoutubePlayer from "@/components/mixins/youtubePlayer.js";
export default {
  data() {
    return {
      video_index: -1,
      is_expand: false,
      degree: 360,
      banner_degree: 0,
      current_banner_index: 0,
      len: 5,
      vw: 0,
      vh: 0,
      iosFullscreen: false,
      player: null,
    };
  },
  computed: {
    isamnet() {
      let domain = window.location.hostname;
      let isAmnet = "https://cdn.aralego.net/rich_media/assets";
      if (domain === "prism.amnet.tw") {
        isAmnet += "/amnet/rollingCastle-bg.png";
      } else {
        isAmnet += "/rollingCastle/bg.png";
      }
      return isAmnet;
    },
  },
  mixins: [mixPreview, mixMobile, mixOutstream, mixYoutubePlayer],
  async mounted() {
    this.viewport();
    await this.$nextTick();
    const vh =
      window.innerHeight ||
      window.document.documentElement.clientHeight ||
      window.document.body.clientHeight;
    const vw =
      window.innerWidth ||
      window.document.documentElement.clientWidth ||
      window.document.body.clientWidth;
    const card_wrapper = document.querySelector(".ucf-revolver-card-wrapper");
    const card_container = document.querySelector(
      ".ucf-revolver-card-container"
    );
    const cards = document.querySelectorAll(".ucf-revolver-cards");
    const banner_wrapper = document.querySelector(".ucf-revolver-banner");

    cards.forEach((card, index) => {
      this.setStyle(card, {
        transform: "rotateY(" + index * 72 + "deg) translateZ(228px)",
      });
    });

    setTimeout(() => {
      this.setStyle(card_container, { transform: "rotateY(360deg)" });

      cards.forEach((card, index) => {
        this.setStyle(card, {
          transform: "rotateY(" + index * 72 + "deg) translateZ(126px)",
        });
      });
    }, 500);

    this.video_index = this.creative.banners.findIndex(
      (banner) => banner.type === "video"
    );

    if (this.video_index !== -1) {
      let bannerVideo = this.creative.banners[this.video_index];
      let vast_xml = bannerVideo.vast_xml;
      let video_id = bannerVideo.youtube_video_id;

      const target = document.querySelector(
        `.ucf-revolver-banner-cards.card-${this.video_index + 1}`
      );

      if (video_id) {
        let tag = document.createElement("script");
        tag.src = "https://www.youtube.com/iframe_api";
        let firstScriptTag = document.getElementsByTagName("script")[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        window.onYouTubeIframeAPIReady = () => {
          this.player = this.addYtPlayer(target, video_id, 640, 1138);
          this.video_div.removeAttribute("style");
          this.setStyle(this.video_div, {
            cursor: "pointer",
            "border-radius": "10px",
            height: "100%",
            width: "100%",
          });
          let video_frame = document.getElementById("player");
          this.setStyle(video_frame, {
            "border-radius": "10px",
          });
        };
      }
      if (vast_xml) {
        vast_xml = this.removeTrackingEvent(vast_xml);
        this.addPlayer(target, 640, 1138);
        this.setStyle(this.video_div, {
          cursor: "pointer",
          "border-radius": "10px",
          height: "100%",
          width: "100%",
        });
        this.setStyle(this.video_frame, {
          "background-color": "black",
          "border-radius": "10px",
          transform: "translateZ(-40px)",
        });
        if (this.isFullscreenAvailable()) {
          this.showFullScreenBtn();
          target.onclick = (e) => {
            const fullScreenBtn = this.video_frame.contentDocument.querySelector(
              "#fullscreen"
            );
            fullScreenBtn.click();
          };
        } else {
          target.onclick = (e) => {
            this.iosFullscreen = true;
            const banner_scene = document.querySelector(
              ".ucf-revolver-banner-scene"
            );
            const banner_cards = document.querySelectorAll(
              ".ucf-revolver-banner-cards"
            );
            const closebutton = document.querySelector(".closebutton");
            const exitFullscrennbtn = document.querySelector(
              ".ios-exit-fullscreen-btn"
            );
            this.setPlayerSize(vw, vh);
            this.video_frame.style.transform = "translateZ(0px)";
            this.video_frame.style["border-radius"] = "0px";
            banner_scene.style.top = "0px";
            banner_scene.style.margin = "0px";
            for (let i = 0; i < banner_cards.length; i = i + 1) {
              if (i !== this.video_index)
                banner_cards[i].style.transform =
                  "rotateY(" +
                  this.video_index * 72 +
                  "deg) translateZ(-100px)";
              else {
                banner_cards[this.video_index].style.transform =
                  "rotateY(" + this.video_index * 72 + "deg) translateZ(0px)";
              }
            }
            closebutton.style["z-index"] = -1;
            this.addEvent(window, "visibilitychange", this.exitFullscreen);

            let adSize = vw > vh ? vw : vh;
            let exitBtnSize = adSize * 0.1 > 32 ? 32 : adSize * 0.1;
            let exitBtnImgSize = adSize * 0.06 > 20 ? 20 : adSize * 0.06;
            exitFullscrennbtn.style.width = exitBtnSize + "px";
            exitFullscrennbtn.style.height = exitBtnSize + "px";
            exitFullscrennbtn.style["background-size"] =
              exitBtnImgSize + "px " + exitBtnImgSize + "px ";

            this.showProgressBar();
            this.showSoundBtn();
            this.showPlayBtn();
          };
        }
      }
      for (let prefix of this.prefixes) {
        this.addEvent(
          document,
          prefix + "fullscreenchange",
          this.fullscreenchangeHandler
        );
      }
    }
    this.setSize();

    this.left = () => this.handleGesture("left");
    this.right = () => this.handleGesture("right");

    this.handleTouch(card_wrapper);
    this.handleTouch(banner_wrapper);
    this.handleAnimate(card_wrapper);
    this.handleAnimate(banner_wrapper);
    this.addEvent(window, "resize", this.setSize);
  },
  methods: {
    exitFullscreen() {
      const banner_scene = document.querySelector(".ucf-revolver-banner-scene");

      this.removeEvent(window, "visibilitychange", this.exitFullscreen);
      this.iosFullscreen = false;

      const closebutton = document.querySelector(".closebutton");
      banner_scene.style.margin = "0 auto";
      closebutton.style["z-index"] = 50000;
      this.setSize();
      let bannerVideo = this.creative.banners[this.video_index];
      let vast_xml = bannerVideo.vast_xml;
      let video_id = bannerVideo.youtube_video_id;
      if (vast_xml) {
        this.video_frame.style["border-radius"] = "10px";
        this.video_frame.style.transform = "translateZ(-40px)";
        this.setPlayerSize(640, 1138);
        this.hideProgressBar();
        this.hideSoundBtn();
        this.hidePlayBtn();
      }
      if (video_id) {
        let video_frame = document.getElementById("player");
        video_frame.style["border-radius"] = "10px";
        video_frame.style.transform = "translateZ(-40px)";
        this.player.setSize(640, 1138);
      }
    },
    handleGesture(gesture) {
      if (this.isAnimating) return;
      if (this.is_expand) {
        if (gesture === "left") {
          this.banner_degree -= 72;
          this.current_banner_index =
            (this.current_banner_index + 1) % this.len;
        } else {
          this.banner_degree += 72;
          this.current_banner_index =
            (this.current_banner_index + this.len - 1) % this.len;
        }

        const banner_container = document.querySelector(
          ".ucf-revolver-banner-container"
        );
        this.setStyle(banner_container, {
          transform: "rotateY(" + this.banner_degree + "deg)",
        });

        setTimeout(() => {
          for (let i = 0; i < this.len; i++) {
            let card = document.querySelector(
              ".ucf-revolver-banner-cards.card-" + (i + 1)
            );
            let x = i - this.current_banner_index;
            if (Math.abs(x) === this.len - 1) {
              x = -x % (this.len - 2);
            }
            this.setStyle(card, {
              "z-index": x === 0 ? 1 : Math.abs(x) === 1 ? 0 : -1,
            });
          }
          if (this.video_index !== -1) {
            let bannerVideo = this.creative.banners[this.video_index];
            let vast_xml = bannerVideo.vast_xml;
            let video_id = bannerVideo.youtube_video_id;
            if (this.current_banner_index === this.video_index) {
              this.isVideoViewable = true;
              if (vast_xml) {
                this.onVideoPlay();
              }
              if (video_id) {
                this.player.playVideo();
              }
            } else {
              this.isVideoViewable = false;
              if (vast_xml) {
                this.onVideoPause();
              }
              if (video_id) {
                this.player.pauseVideo();
              }
            }
          }
        }, 200);
      } else {
        if (gesture === "left") {
          this.degree -= 72;
        } else {
          this.degree += 72;
        }
        document.querySelector(".ucf-revolver-card-container").style.transform =
          "rotateY(" + this.degree + "deg)";
      }
    },
    setSize() {
      const vh =
        window.innerHeight ||
        window.document.documentElement.clientHeight ||
        window.document.body.clientHeight;
      const vw =
        window.innerWidth ||
        window.document.documentElement.clientWidth ||
        window.document.body.clientWidth;
      const banner_scene = document.querySelector(".ucf-revolver-banner-scene");
      const banner_cards = document.querySelectorAll(
        ".ucf-revolver-banner-cards"
      );

      if (!this.iosFullscreen) {
        setTimeout(() => {
          const wrapper = document.querySelector(".ucf-revolver");

          this.height = Math.min(vh * 0.72, (vw * 0.72 * 1138) / 640);
          this.width = Math.min(vw * 0.72, (vh * 0.72 * 640) / 1138);
          const translateZ = this.width * 0.85;

          if (this.isMobile && (vh < 500 || vh > 1580 || vw / vh > 0.75)) {
            wrapper.style.bottom = "-120%";
            wrapper.style.opacity = "0";
          } else {
            let number = this.creative.offset_bottom_number || 0;
            let unit = this.creative.offset_bottom_unit || "px";
            wrapper.style.bottom = `${number}${unit}`;
            wrapper.style.opacity = "1";
            this.setStyle(banner_scene, {
              height: this.height + "px",
              width: this.width + "px",
              top: (vh - this.height) / 2 + "px",
            });
            banner_cards.forEach((banner_card, index) => {
              this.setStyle(banner_card, {
                height: this.height + "px",
                transform:
                  "rotateY(" +
                  index * 72 +
                  "deg) translateZ(" +
                  translateZ +
                  "px)",
              });
            });

            if (this.video_index !== -1) {
              let bannerVideo = this.creative.banners[this.video_index];
              let vast_xml = bannerVideo.vast_xml;
              let video_id = bannerVideo.youtube_video_id;
              if (video_id) {
                this.player.setSize(this.width, this.height);
              }
              if (vast_xml) {
                this.setPlayerSize(this.width, this.height);
              }
            }
          }
        }, 200);
      } else {
        banner_scene.style.top = "0px";
        if (this.video_index !== -1) {
          let bannerVideo = this.creative.banners[this.video_index];
          let vast_xml = bannerVideo.vast_xml;
          let video_id = bannerVideo.youtube_video_id;
          if (video_id) {
            this.player.setSize(vw, vh);
          }
          if (vast_xml) {
            this.setPlayerSize(vw, vh);
          }
        }
      }
    },
    expand(index) {
      const closebutton = document.querySelector(".closebutton");
      const card_wrapper = document.querySelector(".ucf-revolver-card-wrapper");
      const wrapper = document.querySelector(".ucf-revolver");

      this.is_expand = true;
      this.current_banner_index = index;

      closebutton.style.backgroundImage =
        "url('https://cdn.aralego.net/rich_media/assets/mini_btn.png')";
      closebutton.style.backgroundColor = "transparent";

      card_wrapper.style.top = "120%";
      wrapper.style.height = "100%";
      wrapper.style.bottom = "0%";

      this.addEvent(card_wrapper, "transitionend", this.transitionend(index), {
        once: true,
      });

      for (let i = 0; i < this.len; i++) {
        let card = document.querySelector(
          ".ucf-revolver-banner-cards.card-" + (i + 1)
        );
        let x = i - this.current_banner_index;
        if (Math.abs(x) === this.len - 1) {
          x = -x % (this.len - 2);
        }
        this.setStyle(card, {
          "z-index": x === 0 ? 1 : Math.abs(x) === 1 ? 0 : -1,
        });
      }
      if (this.video_index !== -1) {
        let bannerVideo = this.creative.banners[this.video_index];
        let vast_xml = bannerVideo.vast_xml;
        let video_id = bannerVideo.youtube_video_id;
        if (index === this.video_index) {
          this.isVideoViewable = true;
          if (vast_xml) {
            this.onVideoPlay();
          }
          if (this.player && video_id) {
            this.player.playVideo();
          }
        }
      }
    },
    compress() {
      const closebutton = document.querySelector(".closebutton");
      const card_wrapper = document.querySelector(".ucf-revolver-card-wrapper");
      const wrapper = document.querySelector(".ucf-revolver");
      const banner_wrapper = document.querySelector(".ucf-revolver-banner");
      const banner_container = document.querySelector(
        ".ucf-revolver-banner-container"
      );

      this.is_expand = false;

      closebutton.style.backgroundImage =
        "url('https://cdn.aralego.net/rich_media/assets/close_btn.png')";
      closebutton.style.backgroundColor = "white";

      card_wrapper.style.top = "0%";
      wrapper.style.height = "200px";
      let number = this.creative.offset_bottom_number || 0;
      let unit = this.creative.offset_bottom_unit || "px";
      wrapper.style.bottom = `${number}${unit}`;
      banner_wrapper.style.top = "120%";
      banner_wrapper.style.opacity = "0";
      this.banner_degree = 0;
      this.setStyle(banner_container, {
        transform: "rotateY(" + this.banner_degree + "deg)",
      });

      if (this.video_index !== -1) {
        let bannerVideo = this.creative.banners[this.video_index];
        let vast_xml = bannerVideo.vast_xml;
        let video_id = bannerVideo.youtube_video_id;
        this.isVideoViewable = false;
        if (vast_xml) {
          this.onVideoPause();
        }
        if (this.player && video_id) {
          this.player.pauseVideo();
        }
      }
    },
    transitionend(index) {
      const banner_wrapper = document.querySelector(".ucf-revolver-banner");
      const banner_container = document.querySelector(
        ".ucf-revolver-banner-container"
      );
      banner_wrapper.style.top = "0%";
      banner_wrapper.style.opacity = "1";
      this.banner_degree = 720 - index * 72;
      this.setStyle(banner_container, {
        transform: "rotateY(" + this.banner_degree + "deg)",
      });
    },
    setFgStyle(creative) {
      let styleObj = {};

      styleObj = {
        position: "absolute",
        width: creative.width + "%",
        transform: "translateZ(20px)",
      };

      let translateX = "0%";
      let translateY = "0%";
      if (
        creative[`vertical_align`] &&
        creative[`vertical_align`] !== "center"
      ) {
        styleObj[creative[`vertical_align`]] =
          creative[`vertical_padding`] + "%";
      } else {
        styleObj.top = "50%";
        translateY = "-50%";
        styleObj.transform = `translate3d(${translateX}, ${translateY}, 20px)`;
      }

      if (
        creative[`horizontal_align`] &&
        creative[`horizontal_align`] !== "center"
      ) {
        styleObj[creative[`horizontal_align`]] =
          creative[`horizontal_padding`] + "%";
      } else {
        styleObj.left = "50%";
        translateX = "-50%";
        styleObj.transform = `translate3d(${translateX}, ${translateY}, 20px)`;
      }

      return styleObj;
    },
    fullscreenchangeHandler() {
      if (this.hasFullscreenElement()) {
        this.onVideoPlay();
        this.showToolBar();
      } else {
        this.onVideoMute();
        this.hideToolBar();
      }
    },
    messageHandler(e) {
      const frame = document.querySelector("iframe");
      switch (e.data.type) {
        case "close":
          frame.style.display = "none";
          break;
        case "ready":
          this.setPlayerConfig();
          this.initialAd(this.creative.banners[this.video_index].vast_xml);
          break;
        case "Loaded":
          frame.style.display = "block";
          this.isVideoViewable = true;
          this.onVideoPlay();
          this.removeVideoClickDiv();
          break;
        case "Start":
          if (
            !this.is_expand ||
            this.current_banner_index !== this.video_index
          ) {
            this.isVideoViewable = false;
            this.onVideoPause();
          }
          if (this.isMobile && this.hasFullscreenElement()) this.showToolBar();
          break;
        case "error":
          this.$notify.error({
            title: "Error",
            message: e.data.error,
            position: "bottom-right",
            offset: 20,
          });
        default:
          break;
      }
    },
  },
};
</script>

<style lang="sass" scoped>
.ucf-revolver
  width: 100%
  height: 200px
  position: fixed
  bottom: 0px
  opacity: 1
  @include prefix(transition, height 1s, bottom 1s, opacity 1s)
  .closebutton
    cursor: pointer
    position: absolute
    display: block
    width: 32px
    height: 32px
    background-color: white
    background-position: 0 0
    background-image: url('https://cdn.aralego.net/rich_media/assets/close_btn.png')
    z-index: 50000
    top: 0px
    right: 5px
    background-size: contain
    border-radius: 16px
  .ios-exit-fullscreen-btn
    position: absolute
    bottom: 10px
    right: 5px
    z-index: 50000
    cursor: pointer
    background-image: url('https://cdn.aralego.net/rich_media/assets/exitFullscreen_btn.png')
    background-position: center center
    background-repeat: no-repeat
  .ucf-revolver-card-wrapper
    position: absolute
    width: 100%
    height: 200px
    top: 0%
    @include prefix(transition, top 0.5s)
    @include prefix(perspective, 700px)
    .ucf-revolver-card-scene
      top: 50px
      height: 120px
      width: 200px
      margin: 0 auto
      position: relative
      @include prefix(perspective, 700px)
      .ucf-revolver-card-container
        width: 100%
        @include prefix(transform-origin, center center)
        @include prefix(transform, rotateY(0))
        @include prefix(transition, transform 1s)
        @include prefix(transform-style, preserve-3d)
        .ucf-revolver-cards
          position: absolute
          width: 80%
          left: 10%
          opacity: 0.95
          overflow: hidden
          @include prefix(transition, transform 1s)
          img
            width: 100%
            cursor: pointer
            border-radius: 10px
  .ucf-revolver-banner
    height: 100%
    width: 100%
    position: absolute
    top: 120%
    opacity: 0
    @include prefix(transition, top 1s, opacity 1s)
    .ucf-revolver-banner-scene
      margin: 0 auto
      position: relative
      @include prefix(perspective, 2000px)
      .ucf-revolver-banner-container
        width: 100%
        @include prefix(transform-origin, center center)
        @include prefix(transform, rotateY(0))
        @include prefix(transition, transform 1s)
        @include prefix(transform-style, preserve-3d)
        .ucf-revolver-banner-cards
          overflow: visible
          position: absolute
          width: 100%
          @include prefix(perspective, 2000px)
          @include prefix(transform-style, preserve-3d)
          #image-div
            position: absolute
            width: 100%
            height: 100%
            &.float
              @include prefix(animation, Floating 3s infinite ease-in-out)
            img
              cursor: pointer
              position: absolute
              background: rgba(0, 0, 0, 0.01)
              &.background-image
                width: 100%
                @include prefix(transform, translateZ(-40px))

@include keyframes(Floating)
  0%
    @include prefix(transform, translate(0, 0px))
  65%
    @include prefix(transform, translate(0, 15px))
  100%
    @include prefix(transform, translate(0, 0px))
</style>
